module.exports = __webpack_public_path__ + "static/serverless-4c26a2315ab5411ae00b6efd97cc6d21.png";